export const STATUS_SUCCESS = 'success';
export const ORDER_STATUS_ORDER_RECEIVED = 0;
export const ORDER_STATUS_PROCESSING = 1;
export const ORDER_STATUS_ON_THE_WAY = 2;
export const ORDER_STATUS_DELIVERED = 3;
export const ORDER_STATUS_CUSTOMER_REJECTED = 6;
// export const SERVER_URL = 'https://demo.silverbluewater.com';
